import { Expose } from "@nts/std/serialization";
import { MetaDataDescriptions } from './meta-data-descriptions';
import { PropertyMetaData } from './property-meta-data';
import { UserMetaData } from './user-meta-data';
import { CompareModes, DateTimeOffset, OpenDirections } from "@nts/std/types";
import { DateTimeMetaDataInterface } from "@nts/std/interfaces";

export class DateTimeMetaData extends PropertyMetaData implements DateTimeMetaDataInterface {

    static TYPE = 'DateTime';
    protected override _type = DateTimeMetaData.TYPE;

    @Expose()
    isDateTimeOffset: boolean;

    @Expose()
    compareMode: CompareModes;

    @Expose()
    comparePropertyName: string;

    @Expose()
    minValue: Date | DateTimeOffset;

    @Expose()
    maxValue: Date | DateTimeOffset;

    @Expose()
    openDirection: OpenDirections;

    constructor(
        name?: string,
        descriptions?: MetaDataDescriptions,
        userMetaData?: UserMetaData,
        isRequired?: boolean,
        position?: number,
        isDateTimeOffset?: boolean,
        compareMode?: CompareModes,
        comparePropertyName?: string,
        openDirection?: OpenDirections
    ) {
        super(
            name,
            descriptions,
            userMetaData,
            isRequired,
            position
        );
        this.isDateTimeOffset = isDateTimeOffset;
        this.compareMode = compareMode;
        this.comparePropertyName = comparePropertyName;
        this.openDirection = openDirection;
    }

    override set(data: any) {
        super.set(data);
        if (data?.isDateTimeOffset != null) {
            this.isDateTimeOffset = data.isDateTimeOffset;
        }
    }
}
